import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionContact from "../components/SectionContact";
import "../styles/Landing.css";
import constants from "../utils/constants";

interface IProps {}

interface IState {
  isDesktop: boolean;
  isTablet: boolean;
  name: string;
}

class Landing extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isDesktop: false,
      isTablet: false,
      name: "Jin Hoe Lim",
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    this.setState({
      isDesktop: window.matchMedia(
        "(min-width: " + constants.desktopWidth + "px)"
      ).matches,
      isTablet: window.matchMedia(
        "(min-width: " +
          constants.tabletWidth +
          "px) and (max-width: " +
          (constants.desktopWidth - 1) +
          "px)"
      ).matches,
    });

    window.addEventListener("resize", () => {
      this.setState({
        isDesktop: window.matchMedia(
          "(min-width: " + constants.desktopWidth + "px)"
        ).matches,
        isTablet: window.matchMedia(
          "(min-width: " +
            constants.tabletWidth +
            "px) and (max-width: " +
            (constants.desktopWidth - 1) +
            "px)"
        ).matches,
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => {
      this.setState({
        isDesktop: window.matchMedia(
          "(min-width: " + constants.desktopWidth + "px)"
        ).matches,
        isTablet: window.matchMedia(
          "(min-width: " +
            constants.tabletWidth +
            "px) and (max-width: " +
            (constants.desktopWidth - 1) +
            "px)"
        ).matches,
      });
    });
  }

  render() {
    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100vw",
        }}
      >
        <Container className="sectionProfile" fluid>
          <Row>
            <Col xs={1} lg={2} />
            <Col xs={10} lg={8}>
              <div className="name">Jin Hoe Lim</div>
              <div className="subtitle">
                Full-Stack Software Engineer | Engineering Manager
              </div>
              <div className="subtitle">BCompSci</div>
            </Col>
            <Col xs={1} lg={6} />
          </Row>
        </Container>
        <Container className="sectionSkills" fluid>
          <Row>
            <Col xs={1} lg={2} />
            <Col xs={10} lg={8} className="subheading">
              Skills
              <br />
            </Col>
            <Col xs={1} lg={2} />
          </Row>
          <Row>
            <Col xs={1} lg={2} />
            <Col xs={5} lg={2} className="skills">
              TypeScript
              <br />
              React
              <br />
              AWS
              <br />
              Fastify
              <br />
              Serverless
              <br />
              SQL
            </Col>
            <Col xs={5} lg={6} className="skills">
              Next.js
              <br />
              React Native
              <br />
              Azure
              <br />
              Express
              <br />
              IoT
              <br />
              NoSQL
            </Col>
            <Col xs={1} lg={2} />
          </Row>
        </Container>
        <Container fluid>
          <Row>
            <Col xs={1} lg={2} />
            <Col xs={10} lg={8} className="employment">
              <div className="subheading">Dynamic Ratings</div>
              <div className="subtitle">
                2025 - Present
                <br />
                Full-Stack Software Engineer
              </div>
              <br style={{ margin: "2em" }} />
              <div className="subheading">Wallace Building Systems</div>
              <div className="subtitle">
                2020 - Present
                <br />
                Lead Software Engineer
                <br />
                Software Engineering Manager
              </div>
              <br style={{ margin: "2em" }} />
              <div className="subheading">
                Swinburne University of Technology
              </div>
              <div className="subtitle">
                2018 - 2020
                <br />
                Technical Project Assistant
              </div>
            </Col>
            <Col xs={1} lg={2} />
          </Row>
        </Container>
        <SectionContact />
      </div>
    );
  }
}

export default Landing;
